import * as z from "zod/v4";

const SiblingBatchItem_ = z.object({
  id: z.string(),
  title: z.string().nullable(),
  workOrderCount: z.number().int(),
  totalQuantity: z.number().int().optional(),
  status: z.string(),
  productImages: z
    .array(z.object({ url: z.string(), kind: z.string() }))
    .optional(),
  outputSku: z.string().nullable().optional(),
  inputSku: z.string().nullable().optional(),
});
export const SiblingBatchItem: z.ZodType<SiblingBatchItem> = SiblingBatchItem_;
export interface SiblingBatchItem extends z.infer<typeof SiblingBatchItem_> {}

export const getSiblingBatches = {
  name: "getSiblingBatches" as const,
  input: z.object({ batchId: z.string(), stationId: z.string().optional() }),
  output: z.object({ items: z.array(SiblingBatchItem) }),
};
